import { ProcessStatusEnum } from 'src/app/shared/interfaces/process.interface';

export interface CycleUser {
    userId: string;
    email: string;
    cycleParticipantId?: number;
    imageUrl: string;
    name: string;
    status?: ProcessStatusEnum;
    responsible?: string;
    category?: string;
    isInCycle?: boolean;
    isGloballyVisible?: boolean;
    attribute1?: string; // country
    attribute2?: string; // group
    attribute3?: string; // rank
    lineManagerId?: string;
}

export const CycleUserStatus = {
    '0': 'performanceCycles.notEnabledStatus',
    '1': 'performanceCycles.openStatus',
    '2': 'performanceCycles.incompleteStatus',
    '3': 'performanceCycles.finishedStatus'
};
